import { Reveal } from "./primitives";
import { IMAGES } from "../../lib/site";

const CARDS = [
  {
    img: IMAGES.home,
    label: "Homeowners",
    line: "Cut your bill by up to 90%. Sleep easy.",
  },
  {
    img: IMAGES.business,
    label: "Businesses",
    line: "From 10 kW to 500 kW. Sized right.",
  },
  {
    img: IMAGES.society,
    label: "Housing Societies",
    line: "Lower common-area bills for lifts, pumps and lights.",
  },
];

export const Audience = () => (
  <section
    id="audience"
    className="relative bg-cream py-24 sm:py-32 lg:py-40"
    data-testid="audience-section"
  >
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
        <div>
          <Reveal>
            <p className="eyebrow text-amber mb-5">Who it's for</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="display-serif text-navy text-4xl sm:text-5xl lg:text-[3.6rem] leading-[1.02] tracking-[-0.02em] max-w-[14ch]">
              Built for India. Built for you.
            </h2>
          </Reveal>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {CARDS.map((c, i) => (
          <Reveal key={c.label} delay={i * 0.1}>
            <article
              className="group relative overflow-hidden rounded-[1.6rem] h-[440px] sm:h-[520px]"
              data-testid={`audience-card-${i}`}
            >
              <img
                src={c.img}
                alt={c.label}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
              <div className="absolute inset-0 p-7 flex flex-col justify-end">
                <span className="eyebrow text-amber-400 mb-3">{c.label}</span>
                <p className="display-serif text-white text-2xl sm:text-[1.7rem] leading-snug max-w-[18ch] transition-transform duration-500 group-hover:-translate-y-1">
                  {c.line}
                </p>
              </div>
              <div className="absolute top-6 right-6 h-9 w-9 rounded-full border border-white/40 grid place-items-center text-white/70 text-sm">
                0{i + 1}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
